<template>
  <h2 class="text-lg leading-6 font-medium text-gray-900 mb-2">Selection de date</h2>
  <div class="flex flex-row gap-2 mb-6">
    <select class="input px-1 py-1" style="max-width: 100px" v-model="month">
      <option v-for="n in 12" :key="n" :value="n">{{ MONTHS[n - 1] }}</option>
    </select>
    <select class="input px-1 py-1" style="max-width: 100px" v-model="year">
      <option v-for="n in Object.keys(stats.years)" :key="n" :value="n">{{ n }}</option>
    </select>
  </div>

  <div class="grid gap-y-10">
    <StatsCards
      v-if="stats.months[year]"
      :title="`Statistiques ${MONTHS[month - 1]} ${year}`"
      :stats="stats.months[year][month] || {}"
    />
    <StatsCards :title="`Statistiques ${year}`" :stats="stats.years[year] || {}" />
    <StatsCards v-if="stats.total" title="Statistiques Total" :stats="stats.total" />
    <div class="overflow-x-scroll">
      <h3 class="text-lg leading-6 font-medium text-gray-900">Statistiques Tendance</h3>
      <StatsTable class="mt-4" :stats="stats" :year="year" />
    </div>
  </div>
  <small v-if="stats.calculation" class="block mt-12 text-center">
    Dernier calcul: {{ formatDateTime(stats.calculation) }} <br />Le recalcul des statestiques peuvent avoir un delais
    de 15min
  </small>
</template>

<script>
import { ref, onMounted } from 'vue'
import StatsCards from '@/components/UI/Atom/StatsCards'
import StatsTable from '@/components/UI/Atom/StatsTable'
import useApi from '@/hooks/useApi'
import useFunctions from '@/hooks/useFunctions'
import MONTHS from '@/constants/MONTHS'

export default {
  components: {
    StatsCards,
    StatsTable,
  },
  theme() {
    return {
      title: 'Dashboard',
    }
  },
  setup() {
    const stats = ref({ months: {}, years: {}, total: {}, calculation: 0 })

    const api = useApi()
    const functions = useFunctions()

    onMounted(async () => {
      const { data } = await api.stats.list()
      Object.keys(data).forEach(k => {
        stats.value[k] = data[k]
      })
    })

    const month = ref(new Date().getMonth() + 1)
    const year = ref(new Date().getFullYear())

    return {
      stats,
      MONTHS,
      month,
      year,
      formatDateTime: functions.formatDateTime,
    }
  },
}
</script>

<style></style>
